import {
  GET_PARTNER_INSTITUTIONS,
  GET_PARTNER_INSTITUTION,
  SET_LOADING_PARTNER_INSTITUTION,
  PARTNER_INSTITUTION_ERROR,
  CLEAR_ERRORS_PARTNER_INSTITUTION,
  CLEAR_DATA_PARTNER_INSTITUTION,
} from '../types';

export default (state, action) => {
  switch (action.type) {
    case GET_PARTNER_INSTITUTIONS:
      return {
        ...state,
        partnerInstitutions: action.payload,
        errors: null,
        loading: false,
      };
    case GET_PARTNER_INSTITUTION:
      return {
        ...state,
        partnerInstitution: action.payload,
        loading: false,
        errors: null,
      };
    case SET_LOADING_PARTNER_INSTITUTION:
      return {
        ...state,
        loading: true,
      };
    case PARTNER_INSTITUTION_ERROR:
      return {
        ...state,
        errors: action.payload,
        loading: false,
      };
    case CLEAR_ERRORS_PARTNER_INSTITUTION:
      return {
        ...state,
        errors: null,
        loading: false,
      };
    case CLEAR_DATA_PARTNER_INSTITUTION:
      return {
        ...state,
        partnerInstitutions: [],
        partnerInstitution: {},
        loading: false,
        errors: null,
      };
    default:
      return state;
  }
};
